/*       */

/**
 * Simple Redux Middleware to prevent old actions to override the latest action for @@affectli LOAD actions
 *
 * Only processes actions that start with '@@affectli' and include 'LOAD' and ensures only
 * the latest action of each type updates the store.
 *
 * For entity-scoped loads (e.g. LOAD_AVATAR with meta.id), the key includes meta.id so that
 * each entity's success action is applied. Otherwise multiple in-flight avatar loads would
 * share one "latest" and the first success to arrive could cause the second to be ignored
 * (because meta.timestamp is set at STARTED time and is older), leaving that entity stuck at isLoading: true.
 */

const latestTimestamps = new Map();

const latestActionMiddleware = () => (next) => (action) => {
    if (!action || !action.type || !action.type.startsWith('@@affectli') || !action.type.includes('LOAD') || Object.isFrozen(action.meta)) {
        return next(action);
    }

    const timestamp = action.meta?.timestamp || Date.now();

    if (!action.meta) {
        action.meta = {};
    }

    try {
        if (!action.meta.timestamp) {
            action.meta.timestamp = timestamp;
        }
    } catch (error) {}

    // Key by type + meta.id when present so entity-scoped loads (e.g. avatar per id) each get their success applied
    // issue occurred in this ticket 08e66a24-c60b-11f0-9836-029f07889f5d
    const key = action.meta?.id != null ? `${action.type}:${action.meta.id}` : action.type;
    const latestTimestamp = latestTimestamps.get(key);

    if (latestTimestamp === undefined) {
        latestTimestamps.set(key, timestamp);
        return next(action);
    }

    if (timestamp >= latestTimestamp) {
        latestTimestamps.set(key, timestamp);
        return next(action);
    }

    return { type: '@@OLD_ACTION_IGNORED', meta: { originalAction: action } };
};

export default latestActionMiddleware;
